import { Helmet } from 'react-helmet';

import ContentWrapper from 'Component/ContentWrapper';
import {
    Breadcrumbs as SourceBreadcrumbs
} from 'SourceComponent/Breadcrumbs/Breadcrumbs.component';

/** @namespace Elganso/Component/Breadcrumbs/Component */
export class Breadcrumbs extends SourceBreadcrumbs {
    renderStructured() {
        const { breadcrumbs } = this.props;
        const breadcrumbList = super.renderBreadcrumbList(breadcrumbs);
        const listItem = [];
        breadcrumbList.forEach((item) => {
            listItem.push({
                '@type': 'ListItem',
                position: item.props.index,
                item: {
                    '@id': item.props.url.pathname ? item.props.url.pathname : item.props.url,
                    name: item.props.name
                }
            });
        });
        const data = {
            '@context': 'http://schema.org/',
            '@type': 'BreadcrumbList',
            itemListElement: [
                listItem
            ]
        };

        return JSON.stringify(data);
    }

    render() {
        const { breadcrumbs } = this.props;

        if (super.shouldHideBreadcrumbs()) {
            return null;
        }

        return (
            <ContentWrapper mix={ { block: 'Breadcrumbs' } } label={ __('Breadcrumbs (current location)...') }>
                <Helmet>
                    <script className="structured-data-list" type="application/ld+json">{ this.renderStructured() }</script>
                </Helmet>
                <nav aria-label="Breadcrumbs navigation">
                    <ul
                      block="Breadcrumbs"
                      elem="List"
                      itemScope
                      itemType="http://schema.org/BreadcrumbList"
                    >
                        { (
                            breadcrumbs.length
                                ? super.renderBreadcrumbList(breadcrumbs)
                                : super.renderBreadcrumb({}, 0)
                        ) }
                    </ul>
                </nav>
            </ContentWrapper>
        );
    }
}

export default Breadcrumbs;
